import React, {Component} from "react";
import {STR_NO_VALUE, TEXT_FIELD_TYPE_NUMBER} from "./ProsConnect";
import TextInput from "../components/TextInput";
import {showMandatoryAndMissingMessage} from "./ProsCommonUi";

export default class ProsTxtTagMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            txt: (this.props.txt === '-' || this.props.txt === STR_NO_VALUE) ? '' : (this.props.txt || '')
        }
    }

    checkKeyPress(evt) {
        if (evt.shiftKey && evt.key === "Enter") {
            return null
        }
        if (evt.key === "Enter") {
            this.props.onChange(evt.target.value.replace(/\n$/, ""))//remove last line break
        }
    }

    render() {
        let isNumber = this.props.textFieldType === TEXT_FIELD_TYPE_NUMBER
        const isMandatoryAndMissing = this.state.txt.length < 1 && this.props.isMandatoryAndMissing
        return <>
            {showMandatoryAndMissingMessage(isMandatoryAndMissing)}
            <TextInput
                label={this.props.label}
                value={this.state.txt}
                onChange={val => {
                    this.setState({txt: val})
                    if(this.props.onChange) this.props.onChange(val)
                }}
                onKeyUp={(evt) => this.checkKeyPress(evt)}
                multiline={isNumber ? undefined: 5}
                type={isNumber ? "number" : "text"}
                autoFocus
                placeholder={isNumber ? "Kirjoita numero..." : "Kirjoita..."}
                required={isMandatoryAndMissing}
                isValid={this.state.txt.length > 0}
            />
        </>
    }
}